export class PaymentHistory {
  constructor() {
    this.id = null;
    this.statusCode = null;
    this.createdDate = null;
    this.status = null;
    this.fromAccountName = null;
    this.fromAccountSortCode = null;
    this.fromAccountAccountNumber = null;
    this.toAccountName = null;
    this.toAccountSortCode = null;
    this.toAccountAccountNumber = null;
    this.reference = null;
    this.amount = null;
  }
}
export default PaymentHistory;
